import { Dispatch, useState } from "react";
import { TypeSuggestionData } from "~/typings/types";
import { cleanText, clientApi, sanitizeData, sanitizeObject } from "~/utils";
import { GetErrorSuggestions } from "../FormFieldAutocomplete";

export const useSuggestions = <T extends TypeSuggestionData>(
  clientId: string,
  setErrorGetSuggestions: Dispatch<GetErrorSuggestions>,
  url: string
) => {
  const [suggestions, setSuggestions] = useState<T[]>([]);
  const [isPendingResponseSuggestions, setIsPendingResponseSuggestions] = useState(false);

  const fetchSuggestions = async (query: string) => {
    try {
      setIsPendingResponseSuggestions(true);
      setErrorGetSuggestions(null);

      const data = await clientApi.post(url, {
        id: cleanText(clientId),
        q: sanitizeData(query)
      });
      setSuggestions(sanitizeObject(data.data.fields));
    } catch (error: any) {
      setErrorGetSuggestions(sanitizeObject(error?.response?.data?.error?.[0]));
    } finally {
      setIsPendingResponseSuggestions(false);
    }
  };

  return {
    suggestions,
    setSuggestions,
    isPendingResponseSuggestions,
    fetchSuggestions
  };
};
